import { HostDeckShell } from './HostDecksPage.jsx'
import DeckManager from '../components/admin/DeckManager.jsx'

export default function DiscoverDecksPage() {
  return (
    <HostDeckShell rootPath="/host/discover" rootLabel="Découvrir">
      <DeckManager
        communityOnly
        darkMode
        navBase="/host/discover"
        noLocationSnackbar
      />
    </HostDeckShell>
  )
}
